module.exports = __webpack_public_path__ + "img/register-background.eb7e4bf5.jpg";